import React, { useEffect, useState, useRef } from "react";
import { getPdfData, updateFlipBookPdf } from "../../Web Apis/webApis";
import NewLoad from "../Load/Load";
import { message } from "antd";
import { useFormik } from "formik";
import * as Yup from "yup";
import { MdOutlineFileDownload } from "react-icons/md";

const PdfData = ({ setShowModal }) => {
  const [loading, setLoading] = useState(false);
  const [flipBookData, setFlipBookData] = useState({});

  const fileRef = useRef(null);

  const fetchData = async () => {
    try {
      setLoading(true);

      const response = await getPdfData();
      if (response?.data?.success) {
        console.log("res pdf", response);
        setFlipBookData(response?.data?.data);
      }
    } catch (error) {
      console.error("Error fetching flipbook pdf details", error);
      if (
        error.message === "Network Error" ||
        error.message.includes("ERR_INTERNET_DISCONNECTED")
      ) {
        // Handle internet disconnection
        return;
      }
      // Handle specific error cases
      if (error?.response?.status === 401) {
        window.alert(
          "Your account is logged in to another device, please login again !"
        );
        localStorage.removeItem("token");
        // setIsAuthenticated(false)
        window.location.href = "/login";
      }
      if (error?.response?.status === 500) {
        message.error("Server not responding");
        return;
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      file: null,
      flipBookName: flipBookData?.flipBookName || "",
    },
    validationSchema: Yup?.object({
      flipBookName: Yup.string().required("Flipbook name is mendatory"),
    }),
    onSubmit: async (values, { setSubmitting }) => {
      try {
        
        setLoading(true);

        const payload = new FormData();

        if (values.flipBookName)
          payload.append("flipBookName", values?.flipBookName);
        if (values.file) payload.append("file", values?.file);

        const response = await updateFlipBookPdf(payload, flipBookData?.id);
        if (response?.data?.success) {
          message.success(response?.data?.message);
          setShowModal(false);
        }
      } catch (error) {
        console.log("Error while updating the flipbook file", error);
        message.error(error?.response?.data?.message);
      } finally {
        setLoading(false);
        setSubmitting(false);
      }
    },
  });

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      formik.setFieldValue("file", file);
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white  rounded-lg shadow-lg w-[550px] h-[400px] flex flex-col">
        <h3 className="text-xl font-bold mb-1 text-center bg-gradient-to-br from-teal-950 to-teal-500 py-2 text-white">
          Update PDF Document
        </h3>


        <div className="flex-1 overflow-y-auto p-8 scrollbar-hidden">
          <form>
            {flipBookData?.flipBookUrl !== "" ? (
              <div>
                <div
                  className="flex items-center justify-between bg-gray-100 p-2 rounded-md border-b-2"
                >
                  <span className="text-sm text-gray-800">
                    {flipBookData.flipBookName}
                  </span>
                  <a href={flipBookData.flipBookUrl} target="blank" download>
                    <MdOutlineFileDownload className="text-blue-500 hover:underline cursor-pointer text-2xl" />
                  </a>
                </div>
              </div>
            ) : (
              <div></div>
            )}

            <div className="w-full mt-4">
              <label className="block mb-1 font-semibold">Flipbook Name</label>
              <input
                type="text"
                name="flipBookName"
                className="border border-gray-800 p-2 w-full"
                value={formik.values.flipBookName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                placeholder="Please enter the flipbook name"
              />
            </div>

            <div className="w-full mt-4 ">
              <label className="block mb-1 font-semibold">
                Flipbook PDF File
              </label>
              <input
                type="file"
                onChange={handleFileChange}
                accept=".pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                className="w-full border border-gray-300 p-2 rounded-md"
              />
            </div>
          </form>
        </div>


        <div className="flex justify-end p-4 border-t border-gray-500 gap-2">
          <button
            onClick={() => setShowModal(false)}
            className="bg-gray-300 text-black w-52 py-2 px-4 rounded-md hover:bg-red-400 transition duration-200"
          >
            Close
          </button>

          <button
            onClick={formik.handleSubmit}
            className="bg-blue-400 text-black w-52 py-2 px-4 rounded-md hover:bg-green-400 transition duration-200"
          >
            {formik?.isSubmitting ? "Updating..." : "Update"}
          </button>
        </div>
      </div>
      {loading && <NewLoad />}
    </div>
  );
};

export default PdfData;
